import ACLStore from "lib/aclStore";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { ENABLE_STANDARDS_V2 } from "Constants/permissionConstants";
import { PreviewSet } from "SubjectStandardsV2/routes";
import ScopeAndSequenceWrapper from "./routes/ScopeAndSequenceWrapper";

export default store => ({
  path: "scopeandsequence",
  component: withAsyncRouteLoading(() => {
    const isStandardsV2Enabled = ACLStore.can(ENABLE_STANDARDS_V2);
    if (isStandardsV2Enabled) {
      return Promise.all([
        import(/* webpackChunkName: "content-skills" */ "Datasets/components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      });
    } else {
      return Promise.all([
        import(/* webpackChunkName: "content-skills" */ "./component"),

        import(
          /* webpackChunkName: "content-skills" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "content-skills" */ "SubjectsSetup/modules/SubjectsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const subjectSetupReducer = importedModule2.default;
        injectReducer(store, {
          key: "subjectsSetup",
          reducer: subjectSetupReducer,
        });
        injectReducer(store, {
          key: "multiLevelNodeEditor",
          reducer,
        });
        return component;
      });
    }
    //.catch(err => {
    //   throw err;
    // })
  }),
  childRoutes: [PreviewSet(store), ScopeAndSequenceWrapper(store)],
});
